export default __webpack_public_path__ + "static/media/mw_jack_6.a7a3b0b9.png";